import $$ from 'cmn-utils'
const BaseUrl = "/api/temp/snapshot/";
export default {
    list: (params) => {
        return $$.get(BaseUrl + `list`, params);
    },
    create: (params) => {
        return $$.post(BaseUrl + `create`, params);
    },
    delete: (params) => {
        return $$.post(BaseUrl + `delete`, params);
    },
    handle: (params) => {
        return $$.post(BaseUrl + `handle`, params);
    },
}